import { Button, Stack, Typography } from "@mui/material";
import styled from "styled-components";
import { useModal } from "../../../../hooks/useModal";
import { Popup } from "../../../Popup/Popup";
import { CustomEvent, SpontaneousEvent } from "../../../../interface/CustomEvent";
import { Task } from "../../../../interface/Task";
import RoundResultPopup from "./RoundResultPopup";
import { Timestamp } from "../../../../interface/Timestamp";
import { useEffect } from "react";

interface Props {
  roundScores: Timestamp[],
  tasks: Task[],
  events: CustomEvent[],
  average: number,
  finalScore: number,
  showScore: boolean
}


const RoundScore = ({ roundScores, tasks, events, average, finalScore, showScore }: Props) => {
  const { isShown: showPopup, toggle: togglePopup } = useModal();

  return (
    <Stack>

      <ValueField className="container-result">
        {/*
        <Button variant="contained" style={{ "flexDirection": "column", "height": "90px", "width": "100%", "textAlign": "center" }} onClick={togglePopup}>
        */}
          <Typography variant="h4"  className="font-score">

            {showScore ? finalScore : "-"}
          </Typography>
          <Typography className="font-list">
            points
          </Typography>
        {/*
        </Button>
        */}
      </ValueField>

      <Popup
        isShown={showPopup}
        hide={togglePopup}
        headerText={"Sommaire de la ronde"}
        modalContent={<RoundResultPopup roundScores={roundScores} average={average} events={events}
          finalScore={finalScore} tasks={tasks}/>}
      />
    </Stack>
  );
};


const ValueField = styled.div`
    font-size: 1.875em;
`


export default RoundScore;